require('../../../modules/es.array.concat');

module.exports = require('../../../internals/entry-virtual')('Array').concat;
